import config from 'Config';

function getServerUrl() {
    return config.serverUrl;
}

export default getServerUrl;
